import React from 'react';
import EditGeoLocation from '../../../ManageLocation/GeoLocation/Edit';

function EditNCAGeoFence() {
  return <EditGeoLocation editNca={true} />;
}

export default EditNCAGeoFence;
